import styled, { AnyStyledComponent } from 'styled-components';
import Colors from '../../style/universal.color';

import { WrapperProps, Elevation } from './card.types';

const { mlbWhite, mlbGrey8 } = Colors;

const handleElevation = (elevation: Elevation | undefined): string => {
  switch (elevation) {
    case Elevation.SUBTLE:
      return '0px 1px 3px rgba(0, 0, 0, 0.08)';
    case Elevation.MEDIUM:
      return '0px 1px 6px rgba(0, 0, 0, 0.16)';
    case Elevation.PROMINENT:
      return '0px 4px 9px rgba(0, 0, 0, 0.24)';
    default:
      return 'none';
  }
};

export const Wrapper: AnyStyledComponent = styled.div`
    background: ${ ({ theme }: WrapperProps) => theme?.dark ? mlbGrey8 : mlbWhite };
    border-radius: 8px;
    box-shadow: ${ ({ $elevation }: WrapperProps) => handleElevation($elevation)};
    overflow: auto;
    ${ ({ $hideIfEmpty }: WrapperProps) => $hideIfEmpty && `
        &:empty {
          display: none
       }
    `};
`;
